import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_AdvisorWizard } from './ModuleFE_AdvisorWizard.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
const Props_DropDown = {
    module: ModuleFE_AdvisorWizard,
    modules: [ModuleFE_AdvisorWizard],
    mapper: item => [item.label],
    placeholder: 'Choose an Advisor Wizard',
    renderer: item => _jsx(_Fragment, { children: item.label }),
    caret: DropDown_DefaultCaret,
};
export const DropDown_AdvisorWizard = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_AdvisorWizard,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_AdvisorWizard.selectable,
});
export const MultiSelect_AdvisorWizard = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map